import { Alert, LinearProgress } from "@mui/material";
import { AccountListGrid } from "../../modules/ce-admin/components/account-list-grid";
import { CeAdminSupabaseAccountService } from "../../modules/generic/server/supabase-account-service";
import { Page } from "../../modules/layout/components/page";
import { PageContent } from "../../modules/layout/components/page-content";
import { PageHeader } from "../../modules/layout/components/page-header";
import { PageHeading } from "../../modules/layout/components/page-heading";
import { useSupabaseLoader } from "../../server/supabase/hooks";
import { CeAdminPageHeader } from "./ce-admin-page-header";

import type { AdminAccountLimit } from "../../modules/generic/server/supabase-account-service";
import type { FC } from "react";

const CeAdminPage: FC = () => {
  const { data, loading, error } = useSupabaseLoader<AdminAccountLimit[], "ce_admin">(
    async ({ supabase }) => {
      const { data: accounts, error: err } = await new CeAdminSupabaseAccountService(
        supabase,
      ).getAccountLimits();
      if (err) throw new Error("Could not load accounts");
      return accounts ?? [];
    },
    [],
    "ce_admin",
  );

  return (
    <Page title="Administration | ChangeEngine">
      <PageHeader sx={{ display: "flex" }}>
        <PageHeading
          heading={<CeAdminPageHeader />}
          subheading="Accounts — click a row to manage an account"
        />
      </PageHeader>
      <PageContent>
        {loading && <LinearProgress />}
        {error && <Alert severity="error">{error.message}</Alert>}
        {data && <AccountListGrid accounts={data} />}
      </PageContent>
    </Page>
  );
};

export default CeAdminPage;
